import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserAuthService } from '../user-auth.service';
import { AuthResponse } from '../auth-response';
import { Router, ActivatedRoute } from '@angular/router';

// just for testing:
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
	providers: []
})
export class LoginComponent implements OnInit {

	user: User = new User;

	path = [];

	isLoading = false;

	errorMessage: string;

	constructor(
		private userAuthService: UserAuthService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {}


	clickSubmit( email: string, password: string ) {
		this.setUserEmail(email);
		this.setUserPassword(password);
		this.login(email, password);
	}

	setUserEmail( email: string ) {
		this.user.email = email;
	}

	setUserPassword( password: string ) {
		this.user.password = password;
	}

	/* use localStorage to store current user */
	// https://stormpath.com/blog/where-to-store-your-jwts-cookies-vs-html5-web-storage
	login(username: string, password: string) {

		this.isLoading = true;

		this.userAuthService.authenticate(username, password)
							.finally( // triggers independently of success or error
								() => {
									this.isLoading = false;
								}
							)
							.subscribe(
								(authenticatedUser: AuthResponse) => {
									console.log(authenticatedUser);
									if ( authenticatedUser.success ) {
										localStorage.setItem( 'donna-user-auth', JSON.stringify( authenticatedUser ) );
										this.router.navigate( ['clients'] );
									} else {
										this.errorMessage = 'Feil brukernavn eller passord';
									}
								},
								error => {
									this.errorMessage = 'Feil brukernavn eller passord';
								}
							)

	}

	/* check if logged in. if so, redirect to /clients */
	isLoggedIn() {

		this.userAuthService.isLoggedIn().subscribe( 
			res => {
				if ( res.status == 200 ) {
					this.router.navigate( ['clients'] );
				}
			}
		);

	}

	ngOnInit() {

		this.activatedRoute.url.subscribe(
								(path) => {
									this.path = path;
								}
							);

		 // logout user if path is 'logout', then redirect to login
		if ( this.path[0].path == 'logout' ) {
			this.userAuthService.logout().subscribe(
				res => {
					this.router.navigate( ['login'] );
				}
			);
		} else if ( this.path[0].path == 'login' ) {
			this.isLoggedIn();
		}

	}

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts